<template>
    <l-polygon v-if="visible" :lat-lngs="polyLatLng" :color="polyColor" :opacity="0.3" :fillColor="polyColor">
        <l-tooltip>
            {{polyHint}}
        </l-tooltip>
    </l-polygon>
</template>

<script>
import { mapGetters } from 'vuex'
import { LPolygon, LTooltip } from 'vue2-leaflet'
export default {
    name: "UebersichtPolygonAreas",
    components: {
        LPolygon,
        LTooltip,
    },
    props:{
        visible: Boolean
    },
    computed:{
        ...mapGetters(['schulAdresse', 'user']),
        polyColor: function(){
            return !this.user || !this.schulAdresse || this.user.suchStatus == 0 ? '' : this.user.suchStatus == 2 ? 'blue' : 'red'
        },
        polyHint: function(){
            return !this.user ? '' : this.user.suchStatus == 2 ? "Suche in diesem Gebiet nach Mitfahrern" : "Suche in diesem Gebiet nach Fahrern"
        },
        polyLatLng: function() {
            if(!this.user || !this.schulAdresse || this.user.suchStatus == 0)
                return []
            if(this.user.suchStatus == 2){
                var projected = [(this.user.adresse.lng - this.schulAdresse.position.lng) / 6, (this.user.adresse.lat - this.schulAdresse.position.lat) / 2]
                var mitte = [(this.schulAdresse.position.lat + this.user.adresse.lat) / 2, (this.schulAdresse.position.lng + this.user.adresse.lng) / 2]
                return [
                    [this.schulAdresse.position.lat, this.schulAdresse.position.lng],
                    [mitte[0] + projected[0], mitte[1] - projected[1]],
                    [this.user.adresse.lat, this.user.adresse.lng],
                    [mitte[0] - projected[0], mitte[1] + projected[1]],
                ]
            }
            else{
                projected = [(this.user.adresse.lat - this.schulAdresse.position.lat), (this.user.adresse.lng - this.schulAdresse.position.lng)]
                var multiplier = 1 / Math.sqrt(Math.pow(this.user.adresse.lat - this.schulAdresse.position.lat, 2) + Math.pow(this.user.adresse.lng - this.schulAdresse.position.lng, 2))
                var base = [this.user.adresse.lat + multiplier * projected[0], this.user.adresse.lng + multiplier * 2 * projected[1]]
                projected = [(this.user.adresse.lng - base[1]) / 3 * 0.3 * multiplier, (this.user.adresse.lat - base[0]) * 0.3 * multiplier]
                return [
                    [this.user.adresse.lat, this.user.adresse.lng],
                    [base[0] + projected[0], base[1] - projected[1]],
                    [base[0] - projected[0], base[1] + projected[1]],
                ]
            }
        }
    }
}
</script>